export default __webpack_public_path__ + "static/media/1.ae14f0b0.jpeg";